import { AxiosError, AxiosResponse } from "axios";
import { ResponseWithMessage } from "../../../types/ResponseWithMessage";
import toast from "react-hot-toast";

const readError = (value: unknown): string | undefined => {
  if (typeof value === "string" && value.trim()) return value;
  if (Array.isArray(value)) {
    const parts = value
      .map((item) => readError(item))
      .filter((item): item is string => Boolean(item));
    return parts.length ? parts.join(" ") : undefined;
  }
  if (value && typeof value === "object") {
    for (const [key, child] of Object.entries(value as Record<string, unknown>)) {
      const found = readError(child);
      if (!found) continue;
      const label = key.replace(/^(season|episode)_(\d+)$/i, (_, kind: string, n: string) => {
        return `${kind[0].toUpperCase()}${kind.slice(1)} ${n}`;
      });
      if (found.toLowerCase().startsWith(label.toLowerCase())) return found;
      if (/^Season \d+$/.test(label) || /^Episode \d+$/.test(label)) {
        return `${label}: ${found}`;
      }
      return found;
    }
  }
  return undefined;
};

export const handleResponse = <
  T extends
    | AxiosResponse<ResponseWithMessage>
    | AxiosError<ResponseWithMessage>
    | Error
>(
  resp: T,
  callback?: (resp: T) => void
) => {
  let message: string;
  let toastFunction: typeof toast.error | typeof toast.success = toast.error;
  let error = true;

  if (resp instanceof AxiosError) {
    console.error(resp);
    message =
      resp.response?.data?.message ??
      resp.response?.data?.detail ??
      "There was an error!";
    message =
      typeof message === "string"
        ? message
        : Array.isArray(message) && (message as string[])?.join
        ? (message as string[])?.join(",")
        : typeof message === "object"
        ? readError(message) ?? "There was an error!"
        : "There was an error!";
    message = Array.isArray(message) ? message[0] : message;
  } else if (resp instanceof Error) {
    console.error(resp);
    message = "There was an error!";
  } else {
    error = false;
    message = resp.data.message ?? "Success!";
    toastFunction = toast.success;
  }

  console.log(message);

  toastFunction(message);
  if (callback && !error) callback(resp);

  return message;
};
